import http from '@/utils/services/http'

export default {
  getDebitosLote (loteId) {
    return http.get('/api/lote/' + loteId + '/lote-debito')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findDebitoLote (debitoId) {
    return http.get('/api/lote-debito/' + debitoId)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastroDebitoLote (debito, idLote, idDebito) {
    if (idDebito) {
      return this.atualizacaoDebitoLote(debito, idDebito)
    }
    return http.post(`/api/lote/${idLote}/lote-debito`, debito)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacaoDebitoLote (data, id) {
    return http.patch(`/api/lote-debito/${id}`, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteDebitoLote (debitoId) {
    return http.delete(`/api/lote-debito/${debitoId}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  listTipoDebito (limit, page, filtros) {
    return http.get('/api/tipo-lote-debito/?page=' + page + '&limit=' + limit + filtros)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrarTipoDebito (data, id = null) {
    if (id) {
      return this.update(data, id)
    }
    return http.post('/api/tipo-lote-debito/', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findTipoDebito (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/tipo-lote-debito/' + id)
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateTipoDebito (data, id) {
    return http.patch('/api/tipo-lote-debito/' + id, JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteTipoDebito (id) {
    return http.delete('/api/tipo-lote-debito/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  listAllTipoDebito () {
    return http.get('/api/tipo-lote-debito/list')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/lote-debito.js